import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
  useTheme,
} from "@mui/material";
import { CheckCircle, ExpandMore, Warning } from "@mui/icons-material";

const calculateProgressPct = (stats) => {
  const readyLeaguesCount = stats.readyLeaguesCount;
  const allLeagues = stats.activeLeaguesCount;
  if (allLeagues === 0) return 100;
  return 100 - Math.round((readyLeaguesCount / allLeagues) * 100);
}
export default function PromotionProgress({ divisions }) {
  const theme = useTheme();

  return (
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="promotion-check-content"
        id="promotion-check-header"
      >
        <Typography variant="h6">Promotion Progress</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {divisions.map((division) => (
            <Grid item xs={3} key={division.divisionId}>
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography variant="h6">
                    {division.divisionName}
                  </Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'right', pr: 2 }}>
                  {division?.stats?.readyLeaguesCount === 0 ? (
                    <CheckCircle color="success" />
                  ) : (
                    <Warning color="warning" />
                  )}
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'right', pr: 2 }}>
                  <LinearProgress
                    variant="determinate"
                    value={calculateProgressPct(division.stats || { readyLeaguesCount: 0, activeLeaguesCount: 0 })}
                    sx={{
                      height: 10,
                      backgroundColor: theme.palette.action.hover,
                      borderRadius: 2,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: theme.palette["primary"].main,
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>
              </Grid>

            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
